<!-- 商家分布图表 -->
<template>
  <div class="com-container" style="width: 120%; height: 120%;">
    <div class="com-chart" ref="map_ref"></div>
  </div>
</template>

<script>
  import axios from "axios";
  import china from "./china.js";
  import { getProvinceMapInfo } from "@/utils/map_utils";
  export default {
    data() {
      return {
        chartInstance: null,
        allData: null,
        mapData: {}, // 所获取的省份的地图矢量数据
      };
    },
    mounted() {
      this.initChart();
      this.getData();
      window.addEventListener("resize", this.screenAdapter);
      this.screenAdapter();
    },
    destroyed() {
      window.removeEventListener("resize", this.screenAdapter);
    },
    methods: {
      async initChart() {
        this.chartInstance = this.$echarts.init(this.$refs.map_ref, "chalk");
        this.$echarts.registerMap("yancheng", china.mapData);
        const initOption = {
          geo: {
            type: "map",
            map: "yancheng",
            top: "0%",
            left: "27%",
            bottom: "20%",
            label: {
              show: true,
              color: "#04D8DF",
            },
            zoom: 0.9,
            emphasis: {
              label: {
                show: true,
                color: "#fff",
              },
              itemStyle: {
                areaColor: "#666",
                borderColor: "#333",
              },
            },

            itemStyle: {
              areaColor: "#666",
              borderColor: "#999",
              borderWidth: 2,
            },
            tooltip: {
              trigger: "item",
            },
          },
          legend: {
            left: "5%",
            bottom: "20%",
            orient: "vertical",
          },

        };
        this.chartInstance.setOption(initOption);
        this.chartInstance.on("click", async (arg) => {
          window.open("https://my.515ugx.com:20082/hotmap");
          const changeOption = {};
          this.chartInstance.setOption(changeOption);
        });
      },
      async getData() {
        const { data: ret } = await axios.get("/middle-two");
        this.allData = ret.data;
        this.updateChart();
      },
      updateChart() {
        // 处理图表需要的数据
        // 图例的数据
        // 半透明的颜色值
        const colorArr1 = [
          "rgba(82,114,191,0.7)",
          "rgba(179,149,12,0.7)",
          "rgba(0,187,131,0.7)",
          "rgba(42,185,189,0.7)",
          "rgba(250,105,0,0.7)",
          "rgba(238,221,120,0.7)",
        ];

        const legendArr = this.allData.map((item, index) => {
          return {
            textStyle: {
              // color: colorArr1[index],
              color: "#fff",
              fontSize: 12,
            },
            name: item.name,
          };
        });
        let tempSeriesArr = this.allData.map((item) => {
          // return的这个对象就代表的是一个类别下的所有散点数据
          // 如果想在地图中显示散点的数据, 我们需要给散点的图表增加一个配置, coordinateSystem:geo
          return {
            type: "effectScatter", // effectScatter
            rippleEffect: {
              scale: 3,
              brushType: "stroke",
            },
            // showEffectOn: 'emphasis',

            name: item.name,
            data: item.children,
            symbolSize: function (val, params) {
              if (params.data.num > 0 && params.data.num < 10) {
                return 6;
              } else if (params.data.num >= 10 && params.data.num < 20) {
                return 10;
              } else if (params.data.num >= 20 && params.data.num < 40) {
                return 14;
              } else if (params.data.num >= 40 && params.data.num < 70) {
                return 18;
              } else {
                return 22;
              }
            },
            coordinateSystem: "geo",
            // symbol: "pin",
          };
        });
        tempSeriesArr.push({
          name: '地区数据',
          type: 'map',
          top: "0%",
          left: "27.8%",
          bottom: "20%",
          zoom: 0.89,
          tooltip: {
            show: true,
            trigger: "item"
          },
          mapType: 'yancheng', // 自定义扩展图表类型
          // geoIndex: 0,
          // aspectScale: 0.75, // 长宽比
          itemStyle: {
            areaColor: "rgba(2,54,92,1)",
            borderColor: "#00DFED",
            borderWidth: 2,
          },
          data: [{
            name: '亭湖区',
            num: '重点工业互联网平台：1<br/>工业互联网标杆工厂：1<br/>省示范智能车间：4<br/>省星级上云：95<br/>数字化诊断：14'
          },{
            name: '盐都区',
            num: '重点工业互联网平台：2<br/>省示范智能工厂：1<br/>省示范智能车间：9<br/>省星级上云：191<br/>数字化诊断:21<br/>'
          },{
            name: '大丰区',
            num: '工业互联网标杆工厂：2<br/>省示范智能车间：3<br/>省星级上云：93<br/>数字化诊断：17'
          },{
            name: '响水县',
            num: '省星级上云：21<br/>数字化诊断：3'
          },{
            name: '阜宁县',
            num: '省示范智能车间：4<br/>省星级上云：77<br/>数字化诊断：8'
          },{
            name: '滨海县',
            num: '省示范智能车间：1<br/>省星级上云：5<br/>数字化诊断：9'
          },{
            name: '东台市',
            num: '省示范智能车间：2<br/>省星级上云：154<br/>数字化诊断：44'
          },{
            name: '射阳县',
            num: '省示范智能车间：2<br/>省星级上云：17<br/>数字化诊断：7'
          },{
            name: '建湖县',
            num: '省示范智能车间：1<br/>省星级上云：24<br/>数字化诊断：7'
          }]
        })
        const seriesArr = tempSeriesArr

        const dataOption = {
          color: [
            "rgba(82,114,191,0.7)",
            "rgba(179,149,12,0.7)",
            "rgba(0,187,131,0.7)",
            "rgba(42,185,189,0.7)",
            "rgba(250,105,0,0.7)",
            "rgba(238,221,120,0.7)",
          ],
          label: {
            fontSize: 12,
          },
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function (params) {
              return (
                params.marker +
                "<sapn style='letter-spacing:5px'>"+params.name+"</sapn>" +"</br>" +
                params.data.num
              );
            },
          },
          legend: {
            data: legendArr,
          },
          series: seriesArr,
        };
        this.chartInstance.setOption(dataOption);
      },
      screenAdapter() {
        const titleFontSize = (this.$refs.map_ref.offsetWidth / 100) * 3.6;
        const adapterOption = {
          title: {
            textStyle: {
              fontSize: titleFontSize,
            },
          },
          legend: {
            itemWidth: titleFontSize / 2,
            itemHeight: titleFontSize / 2,
            itemGap: titleFontSize / 2,
            textStyle: {
              fontSize: titleFontSize / 2,
            },
          },
        };
        this.chartInstance.setOption(adapterOption);
        this.chartInstance.resize();
      },
      // 回到中国地图
      revertMap() {
        window.open("https://my.515ugx.com:20082/hotmap");
      },
    },
  };
</script>

<style lang="less" scoped></style>